


























































import { mixins } from "vue-class-component";
import { Component, Prop, VModel, Watch } from "vue-property-decorator";
import GlobalMixin from "../mixins/globalMixin";
import { ToastService } from "@/services/toast.service";

@Component
export default class FileUpload extends mixins(GlobalMixin) {
  @Prop({ type: Boolean, default: false }) multiple!: boolean;
  @Prop({ type: String, default: "" }) accept!: string;
  @VModel() uploadedFiles!: File | Array<File> | null;

  dragover = false;

  @Watch("multiple", { immediate: true })
  onMultipleChange() {
    if (this.multiple && !Array.isArray(this.uploadedFiles)) {
      this.uploadedFiles = (this.uploadedFiles && [this.uploadedFiles]) || [];
    } else {
      this.uploadedFiles =
        (this.uploadedFiles && (this.uploadedFiles as Array<File>)[0]) || null;
    }
  }

  setValue(value: File | FileList) {
    if (value instanceof FileList) {
      const files = Array.from(value);

      for (const file of files) {
        this.setValue(file);
      }
    } else if (this.multiple) {
      (this.uploadedFiles as Array<File>).push(value as File);
    } else {
      this.uploadedFiles = value as File;
    }
  }

  removeFile(fileName: string) {
    if (Array.isArray(this.uploadedFiles)) {
      const index = this.uploadedFiles.findIndex(
        (file: File) => file.name === fileName
      );
      // If file is in uploaded files remove it
      if (index > -1) this.uploadedFiles.splice(index, 1);
    } else {
      this.uploadedFiles = null;
    }
  }

  onDrop(e: DragEvent) {
    this.dragover = false;
    if (!this.multiple && e.dataTransfer && e.dataTransfer.files.length > 1) {
      ToastService.open({
        message: "É permitido apenas um arquivo!",
        type: "warning",
        position: "bottom-end",
        duration: 3000,
      });
    } else if (e.dataTransfer) {
      this.setValue(e.dataTransfer.files);
    }
  }
}
